var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 0C4.92572 0 0 4.92475 0 11C0 17.0752 4.92524 22 11.0005 22C17.0762 22 22.001 17.0752 22.001 11C22.001 4.92475 17.0762 0 11.0005 0ZM11.0005 3.28913C13.0106 3.28913 14.6394 4.91847 14.6394 6.92761C14.6394 8.93723 13.0106 10.5661 11.0005 10.5661C8.99135 10.5661 7.36249 8.93723 7.36249 6.92761C7.36249 4.91847 8.99135 3.28913 11.0005 3.28913ZM10.9981 19.124C8.99328 19.124 7.15713 18.3939 5.74087 17.1854C5.39587 16.8911 5.19679 16.4597 5.19679 16.0069C5.19679 13.9693 6.84595 12.3385 8.88408 12.3385H13.1179C15.1565 12.3385 16.7993 13.9693 16.7993 16.0069C16.7993 16.4601 16.6012 16.8907 16.2557 17.1849C14.84 18.3939 13.0033 19.124 10.9981 19.124Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSelected);
export default __webpack_public_path__ + "static/media/profileSelected.d8b647f927714698d2ac5d05c8955fbb.svg";
export { ForwardRef as ReactComponent };